import { useQuery as usePageDataInsiderMembershipQuery } from "@faire/web-api--source/endpoints/www/api/page-data/insider-membership/get-hooks";

import { useSettingDecentralizePageData } from "../settings/useSettingDecentralizePageData";

import { getInsiderMemershipInformation } from "./getInsiderMembershipInformation";

export const useInsiderMembershipInformation = () => {
  const isDecentralizedPageData = useSettingDecentralizePageData();

  const { data, isPending } = usePageDataInsiderMembershipQuery({
    staleTime: Infinity,
    refetchOnMount: false,
    enabled: isDecentralizedPageData,
  });

  return isDecentralizedPageData
    ? { data, isPending }
    : { data: getInsiderMemershipInformation(), isPending: false };
};
